import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import {
  booleanValueGetterByField,
  dateFormatter,
  nestedFieldValueGetter
} from 'utils/grid';

import { GridColDef } from '@mui/x-data-grid-pro';

import BooleanCell from 'components/shared/Table/TableCell/DataGrid/BooleanCell';
import { ApiAccounts } from '../types';

export const useGetColumnDefs = () => {
  const { t } = useTranslation('common');

  const columnDefs: GridColDef[] = useMemo(() => {
    return [
      {
        field: 'accountName',
        type: 'string',
        headerName: t('api_accounts.accountName'),
        flex: 1,
        minWidth: 200
      },
      {
        field: 'valid.from',
        type: 'date',
        headerName: t('validFrom'),
        valueGetter: (_, row: ApiAccounts) => nestedFieldValueGetter('valid.from', row),
        valueFormatter: dateFormatter,
        flex: 1,
        minWidth: 120
      },
      {
        field: 'valid.to',
        type: 'date',
        headerName: t('validTo'),
        valueGetter: (_, row: ApiAccounts) => nestedFieldValueGetter('valid.to', row),
        valueFormatter: dateFormatter,
        flex: 1,
        minWidth: 120
      },
      {
        field: 'DISABLED',
        type: 'string',
        valueGetter: (_, row) => booleanValueGetterByField('DISABLED', row),
        renderCell: BooleanCell,
        headerName: t('api_accounts.flags.DISABLED'),
        flex: 1,
        minWidth: 200
      },
      {
        field: 'LOCKED',
        type: 'string',
        valueGetter: (_, row) => booleanValueGetterByField('LOCKED', row),
        renderCell: BooleanCell,
        headerName: t('api_accounts.flags.LOCKED'),
        flex: 1,
        minWidth: 200
      }
    ];
  }, []);

  return columnDefs;
};
